import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import {
  getCompanyLogo,
  getJobExperiences,
  getKeywords,
  getSalaryAmount,
} from "../../../../helpers/common";
import { useSelector } from "react-redux";
import AddToBookmarkJob from "../../../../helpers/Common/AddToBookmarkJob";
import ApplyJobModal from "../../../../helpers/Common/ApplyJobModal";
import userImage6 from "../../../../assets/images/avatar.png";
const BookmarkJobItem = ({ bookmarkItem }) => {
  const navigate = useNavigate();
  const [applyJobModal, setApplyJobModal] = useState(false);
  const [currJob, setCurrJob] = useState({});
  // Hides this card as soon as its bookmark is removed
  const [isRemoved, setIsRemoved] = useState(false);
  const openApplyJobModal = (jobDetails) => {
    setApplyJobModal(!applyJobModal);
    setCurrJob(jobDetails);
  };

  // Getting the company details
  const companyDetails = bookmarkItem?.company;

  // Getting the job details
  const jobDetails = bookmarkItem?.job;
  console.log("Jobdetails@", jobDetails);
  // Job detail page URL (Note: Using jobDetails?.id and jobDetails?.url if available)
  const jobDetailsUrl = `/job/details/${jobDetails.id}/${jobDetails.url}`;

  // Whole card click -> job details page.
  // Clicks on links, buttons, the bookmark icon and badges are ignored here,
  // so they keep their own behaviour (Apply Now, bookmark, title/logo links).
  const handleCardClick = (e) => {
    if (e.target.closest("a, button, .favorite-icon, .btn, .badge")) {
      return;
    }
    navigate(jobDetailsUrl);
  };

  const candidateReducer = useSelector((state) => state.candidate);
  const appliedJobs = candidateReducer.jobApplications;

  const jobs = Array.isArray(appliedJobs)
    ? appliedJobs
    : appliedJobs?.data || [];

  const isAppliedJob = jobs.find((item) => item?.job?.id === jobDetails?.id);

  return (
    <>
      <div
        className={"job-box card mt-4"}
        onClick={handleCardClick}
        style={
          isRemoved
            ? { display: "none" }
            : { cursor: "pointer" }
        }
      >
        <div className="p-4">
          <Row>
            <Col lg={1}>
              <Link to={jobDetailsUrl}>
                <img
                  src={(() => {
                    const logoSrc = companyDetails?.logo
                      ? getCompanyLogo(companyDetails.logo)
                      : userImage6;
                    console.log("--- LOGO DEBUGGER ---");
                    console.log(
                      "Raw companyDetails?.logo value:",
                      companyDetails?.logo,
                    );
                    console.log("Final src string generated:", logoSrc);
                    return logoSrc;
                  })()}
                  alt={companyDetails?.name || "Company Logo"}
                  className="rounded-3 img-thumbnail shadow-sm comp-logo"
                  style={{
                    width: "90px",
                    height: "90px",
                    objectFit: "contain",
                    border: "3px solid #fff",
                  }}
                  onError={(e) => {
                    console.error("--- LOGO LOAD FAILED ---");
                    console.error("Failed URL Attempted:", e.target.src);

                    // Prevent infinite error loops if fallback also fails
                    e.target.onerror = null;
                    e.target.src = userImage6;

                    console.log(
                      "Image source fell back successfully to userImage6.",
                    );
                  }}
                />
              </Link>
            </Col>
            <Col lg={10}>
              <div className="mt-3 mt-lg-0">
                <h5 className="fs-17 mb-1">
                  <Link to={jobDetailsUrl} className="text-dark">
                    {/* FIX: job_title -> jobTitle */}
                    {jobDetails?.jobTitle}
                  </Link>{" "}
                  <small className="text-muted fw-normal">
                    ({getJobExperiences(jobDetails)} Exp.)
                  </small>
                </h5>
                <ul className="list-inline mb-0">
                  <li className="list-inline-item">
                    <p className="text-muted fs-14 mb-0">
                      {companyDetails?.name}
                    </p>
                  </li>
                  <li className="list-inline-item">
                    <p className="text-muted fs-14 mb-0">
                      <i className="mdi mdi-map-marker text-primary"></i>
                      {/* FIX: location.name -> location (string in API) */}
                      {bookmarkItem?.location?.name ||
                        jobDetails?.location ||
                        "India"}
                    </p>
                  </li>
                  <li className="list-inline-item">
                    <p className="text-muted fs-14 mb-0">
                      {getSalaryAmount(jobDetails)}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>

          <AddToBookmarkJob
            size="sm"
            companyDetails={companyDetails}
            jobDetails={jobDetails}
            onRemoved={() => setIsRemoved(true)}
          />
        </div>
        <div className="p-3 bg-light">
          <div className="row justify-content-between align-items-center">
            {/* Trending Keywords */}
            <div className="col-md-8">
              <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center text-primary fw-medium me-2">
                  <i className="uil uil-chart-growing fs-16 me-1"></i>
                  <span className="fs-14">Trending Keywords:</span>
                </div>

                <div className="d-flex flex-wrap gap-2">
                  {jobDetails?.searchKeywords ? (
                    jobDetails.searchKeywords
                      .split(",")
                      .map((keyword, index) => (
                        <span
                          key={index}
                          className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-3 py-2 rounded-pill fw-medium"
                          style={{
                            cursor: "pointer",
                            transition: "all .2s ease",
                          }}
                        >
                          #{keyword.trim()}
                        </span>
                      ))
                  ) : (
                    <span className="text-muted fs-13">No keywords added</span>
                  )}
                </div>
              </div>
            </div>

            {/* Apply Button */}
            <div className="col-md-3">
              <div className="text-md-end mt-3 mt-md-0">
                {isAppliedJob ? (
                  <button
                    className="btn btn-outline-success btn-sm rounded-pill px-3 py-2 fw-semibold"
                    disabled
                  >
                    <i className="uil uil-check-circle me-1"></i>
                    Already Applied
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={() => openApplyJobModal(jobDetails)}
                    className="btn btn-primary btn-sm rounded-pill px-3 py-2 fw-semibold shadow-sm"
                  >
                    <i className="uil uil-arrow-right me-1"></i>
                    Apply Now
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <ApplyJobModal
        currJob={currJob}
        setApplyJobModal={setApplyJobModal}
        applyJobModal={applyJobModal}
      />
    </>
  );
};

export default BookmarkJobItem;